<template>
  <div  v-if="isShow">
    <div class="img-wrapper" @click="close">
      <img class="arrow left" src="../../assets/arrow.png" alt="" @click.stop="toLast" v-if="index!==0 && src.length>0">
      <div class="img-content">
        <img v-if="mediaType===1" class="img" :src="src0" alt="" >
        <video v-if="mediaType===2" :src="src0" controls preload="true" autoplay ></video>
      </div>
      <img class="arrow right" src="../../assets/arrow.png" alt="" @click.stop="toNext" v-if="index<src.length-1">

    </div>

    <div class="back" ></div>

  </div>
</template>

<script>

  export default {
    name: "ImgShow",
    props: {
      src: {
        type: Array,
        default: ()=>{return []}
      },
      n:{
        type:Number,
        default:0
      },
      mediaType:{
        type:Number,
        default:1  //媒体文件类型 1图片  2视频
      }
    },
    data() {
      return {
        isShow: false,
        src0:this.src.length>0?this.src[0]:'',
        index:0,
      }
    },
    watch:{
      n(){
        this.src.length>0 && (this.src0=this.src[0])
        this.index=0
        this.isShow=true
      }
    },
    methods: {
      toLast(){
        this.src0=this.src[this.index-1]
        this.index=this.index-1

      },
      toNext(){
        this.src0=this.src[this.index+1]
        this.index=this.index+1

      },
      close() {
        this.isShow = false
      }
    }
  }
</script>

<style scoped>

  .left{
    left: 2%;
    top: 35%;
    transform: rotate(180deg);

  }
  .right{
    right: 2%;
    top: 35%;
  }
  .arrow{
    width: 3%;
    position: fixed;
    display: inline-block;
    /*margin: auto 0 ;*/
  }



  img {
    max-width: 80%;
    max-height: 85vh;
    display: inline-block;
  }

  .img-content {
    max-width: 50%;
    display: inline-block;
    background-color: white;
    padding: 20px;

  }

  .img-wrapper {
    position: fixed;
    z-index: 1000001;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    overflow: auto;
    padding: 5% 0;
    box-sizing: border-box;
    text-align: center;
  }

  .back {
    position: fixed;
    width: 100%;
    min-height: 100vh;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 100000;
  }

</style>
